// initiate

export const INITIATE = 'ui.add.INITIATE' as const;
export type InitiateAction = {
	type: typeof INITIATE;
};
export const initiate = (): InitiateAction => ({
	type: INITIATE,
});

// cancel

export const CANCEL = 'ui.add.CANCEL' as const;
export type CancelAction = {
	type: typeof CANCEL;
};
export const cancel = (): CancelAction => ({
	type: CANCEL,
});

export type Action = InitiateAction | CancelAction;
